






import { Vue, Component, Prop } from "vue-property-decorator";
import { Overlay } from "vant";

@Component({
  name: "loading",
  components: {
    [Overlay.name]: Overlay,
  },
})
export default class extends Vue {
  @Prop()
  isShow?: boolean;

  loadingImg = require("../../static/img/loading.gif");
}
